import React, { useState } from 'react';
import "styles/FlourishMedia.css";

const items = [
  {
    id: 'press-release',
    title: 'Press Release',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    header: 'Press Release',
    text: 'This is how we do this.',
    link: 'https://www.flourishtalents.com'
  },
  {
    id: 'spotlight',
    title: 'Spotlight',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    header: 'Spotlight',
    text: 'That is how we do that.',
    link: 'https://www.flourishtalents.com'
  },
  {
    id: 'streaming',
    title: 'Streaming',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    header: 'Streaming',
    text: 'This is how we do this.',
    link: 'https://www.flourishtalents.com'
  },
  {
    id: 'podcast',
    title: 'Podcast',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    header: 'Podcast',
    text: 'That is how we do that.',
    link: 'https://www.flourishtalents.com'
  },
  {
    id: 'blog',
    title: 'Blog',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    header: 'Blog',
    text: 'This is how we do this.',
    link: 'https://www.flourishtalents.com'
  },
  {
    id: 'newsletter',
    title: 'Newsletter',
    bgImage: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    header: 'Newsletter',
    text: 'That is how we do that.',
    link: 'https://www.flourishtalents.com'
  }
];

export default function FlourishMedia() {
  const [activeId, setActiveId] = useState(items[0].id);

  return (
    <div className="row-fluid-wrapper row-depth-1 row-number-15 dnd-row">
      <div className="row-fluid">
        <div
          className="span12 widget-span widget-type-custom_widget dnd-module"
          data-widget-type="custom_widget"
          data-x="0"
          data-w="12"
        >
          <div className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module">
            <div className="tab-accordion widget_1737442177651">
              <div className="tabs-container">
                <div className="page-center container">
                  <div className="titles">
                    <h2 className="title has-text-centered mediaposition">
                      Flourish Media
                    </h2>
                  </div>

                  <div className="tabs-content pt-sm-all">
                    <div id="tab-what-we-offer" className="tab-content active">
                      <div className="accordionContainer">
                        <ul className="accordion-items">
                          {items.map((item) => (
                            <li
                              key={item.id}
                              className={`accordion-item ${item.id === activeId ? 'acc-active' : ''}`}
                            >
                              <div
                                className="opener"
                                onClick={() =>
                                  setActiveId(activeId === item.id ? '' : item.id)
                                }
                              >
                                <div className="opener-item">
                                  <div
                                    className="bg-image"
                                    style={{ backgroundImage: `url(${item.bgImage})` }}
                                  />
                                  <h5>{item.title}</h5>
                                </div>
                              </div>
                              <div className="slide">
                                <div className="holder">
                                  <div className="row">
                                    <div className="col">
                                      <div className="img">
                                        <img
                                          src={item.imgSrc}
                                          alt={item.header}
                                          loading="lazy"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-auto align-self-center fs-md">
                                      <h4>{item.header}</h4>
                                      <p>
                                        {item.text.startsWith('<span>')
                                          ? <span>{item.text.replace(/<\/?span>/g, '')}</span>
                                          : item.text}
                                      </p>
                                      <div className="link-group">
                                        <div>
                                          <a className="btn-link" href="javascript:void(0)">
                                            Learn more
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
}
